module.exports = __webpack_public_path__ + "static/img/lianmeng4.2989f18.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xieyi/lianmeng4.jpg
// module id = 1419
// module chunks = 1